import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { total, alert, toFixed, format_date, getStorage,replaceText } from "./CustomComponent.js";

import "../assets/css/bootstrap.css";
import "./global.js";

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
  FCIconic: {
    normal: "FCIconic-Light.ttf",
    bold: "FCIconic-Bold.ttf",
    italics: "FCIconic-Italic.ttf",
    bolditalics: "FCIconic-Italic.ttf",
  },
  THSarabunNew: {
    normal: "THSarabunNew.ttf",
    bold: "THSarabunNew-Bold.ttf",
    italics: "THSarabunNew-Italic.ttf",
    bolditalics: "THSarabunNew-BoldItalic.ttf",
  },
  Roboto: {
    normal: "Roboto-Regular.ttf",
    bold: "Roboto-Medium.ttf",
    italics: "Roboto-Italic.ttf",
    bolditalics: "Roboto-MediumItalic.ttf",
  },
};
async function print(docDefinition) {
  pdfMake.createPdf(docDefinition).print();
}
async function open(docDefinition, filename = "รายงาน.pdf") {
  try {
    pdfMake.createPdf(docDefinition).open();
  } catch (error) {
    pdfMake.createPdf(docDefinition).download(filename);
    if (error === "Open PDF in new window blocked by browser") {
      alert("warning", "แจ้งเตือน", "ไม่สามารถเปิดเอกสารได้เนื่องจากการปิดกั้นจากบราวเซอร์");
    } else {
      alert("warning", "แจ้งเตือน", "กรุณาลองใหม่อีกครั้ง");
    }
  }
}
// การนำส่งเงินค่าใช้จ่าย
async function report_remittance_byid(data, items) {
  let array = [];
  let index = 1;
  let data_cash = data.filter((item) => item.payment_type === 1);
  let data_tranfer = data.filter((item) => item.payment_type === 2);
  for (let item of data) {
    item.count_bill = item.count_bill === 0 ? 1 : item.count_bill;
    item.other_income = item.record_other_list[0] ? item.record_other_list[0].cost + item.fire_cost + item.cable_cost : item.other_income + item.fire_cost + item.cable_cost;
    let debt = item.add_debt + item.add_on_add_debt - (item.reduce_debt + item.add_on_reduce_debt);
    let _total = item.water_bill+item.equipment_maintenance_fee+item.common_expenses+item.waste_cost+item.other_income+debt+item.meter_connect_cost+item.late_payment+item.change_satang;
    item.total_final = _total;
    array.push([
      { text: index, rowSpan: 2 }, 
      { text: item.iw_number }, 
      { text: item.address_number || item.address || "", rowSpan: 2 }, 
      { text: item.full_name, border: [true, true, true, false] }, 
      { text: item.status_bill === 1 ? toFixed(item.water_bill) : "-", rowSpan: 2 }, 
      { text: item.status_bill === 1 ? toFixed(item.equipment_maintenance_fee) : "-", rowSpan: 2 }, 
      { text: item.status_bill === 1 ? toFixed(item.common_expenses) : "-", rowSpan: 2 }, 
      { text: item.status_bill === 1 ? toFixed(item.waste_cost) : "-", rowSpan: 2 }, 
      { text: item.status_bill === 1 ? toFixed(item.other_income) : "-", rowSpan: 2 }, 
      { text: item.status_bill === 1 ? toFixed(debt) : "-", rowSpan: 2 }, 
      { text: item.status_bill === 1 ? toFixed(item.meter_connect_cost) : "-" }, 
      { text: item.status_bill === 1 ? toFixed(item.late_payment) : "-" }, 
      { text: item.status_bill === 1 ? toFixed(item.change_satang) : "-" }]);
    array.push([
      "", 
      { text: format_date(item.record_date, "dd/mm/yyyy") }, 
      "", 
      { text: item.status_bill === 1 ? "ชำระ " + item.count_bill + " รายการ " + (item.payment_type === 2 ? "โอนเงินวันที่ " + format_date(item.transfer_date, "dd/mm/yyyy") : "") : "ยกเลิกใบเสร็จ", border: [true, false, true, true], noWrap: true }, 
      "", "", "", "", "", "", 
      { text: "รวมทั้งสิ้น", fillColor: "#C0C0C0" }, 
      { text: item.status_bill === 1 ? toFixed(item.total_final || 0) : "-", fillColor: "#C0C0C0", colSpan: 2 }, 
      ""
    ]);
    index += 1;
  }
  const docDefinition = {
    content: [
      {
        columns: [
          { text: getStorage("project_name"), alignment: "left", fontSize: 18, bold: true },
          {
            stack: [
              { text: "เลขที่ " + (items ? items.rw_number : "-"), alignment: "right" },
              { text: "วันที่ " + format_date(items.close_job_date, "dd mmmm yyyy"), alignment: "right" },
            ],
          },
        ],
      },
      {
        columns: [
          { width: 220, text: "รายงานการนำส่งเงินค่าใช้จ่ายเข้าบัญชีธนาคาร", fontSize: 14, alignment: "left", bold: true },
          {
            stack: [
              { text: "ปิดงานเวลา " + format_date(items.close_job_date, "hh:mm:ss") + " ผู้ปิดงาน/ตรวจนับใบเสร็จ/นำส่งเงิน " + getStorage("full_name") + " (ลงชื่อ).............................................................................", alignment: "right" },
              { text: "ผู้รับเงินนำฝากธนาคาร (ลงชื่อ).............................................................................", alignment: "right" },
            ],
          },
        ],
      },
      { text: " " },
      {
        table: {
          headerRows: 1,
          widths: ["3.14%", "12.16%", "6.14%", "15.74%", "6.84%", "6.84%", "8.16%", "4.56%", "8.16%", "5.06%", "7.06%", "9.66%", "5.54%"],

          body: [
            [
              { text: "ลำดับ", alignment: "center" },
              { text: "เลขที่ใบเสร็จรับเงิน", alignment: "center" },
              { text: "บ้านเลขที่", alignment: "center" },
              { text: "ชื่อ-นามสกุล", alignment: "center" },
              { text: "ค่าน้ำประปา", alignment: "center" },
              { text: "ค่ารักษา อุปกรณ์น้ำ", alignment: "center" },
              { text: "ค่าส่วนกลาง", alignment: "center" },
              { text: "ค่าขยะ", alignment: "center" },
              { text: "รายรับอื่นๆ", alignment: "center" },
              { text: "เพิ่ม/ลดหนี้", alignment: "center" },
              { text: "ค่าต่อกลับ มิเตอร์", alignment: "center" },
              { text: "ค่าปรับชำระล่าช้า", alignment: "center" },
              { text: "ปรับเศษ", alignment: "center" },
            ],
            ...array,
            [
              { text: "", rowSpan: 2 },
              " ",
              { text: " ", rowSpan: 2 },
              { text: "รวมเป็นเงินทั้งสิ้น", rowSpan: 2 },
              {
                text: toFixed(
                  total(
                    data.filter((item) => item.status_bill !== 2),
                    "water_bill"
                  )
                ),
                rowSpan: 2,
              },
              {
                text: toFixed(
                  total(
                    data.filter((item) => item.status_bill !== 2),
                    "equipment_maintenance_fee"
                  )
                ),
                rowSpan: 2,
              },
              {
                text: toFixed(
                  total(
                    data.filter((item) => item.status_bill !== 2),
                    "common_expenses"
                  )
                ),
                rowSpan: 2,
              },
              {
                text: toFixed(
                  total(
                    data.filter((item) => item.status_bill !== 2),
                    "waste_cost"
                  )
                ),
                rowSpan: 2,
              },
              {
                text: toFixed(
                  total(
                    data.filter((item) => item.status_bill !== 2),
                    "other_income"
                  )
                ),
                rowSpan: 2,
              },
              {
                text: toFixed(
                  total(
                    data.filter((item) => item.status_bill !== 2),
                    "add_debt"
                  ) -
                    total(
                      data.filter((item) => item.status_bill !== 2),
                      "reduce_debt"
                    ) +
                    total(
                      data.filter((item) => item.status_bill !== 2),
                      "add_on_add_debt"
                    ) -
                    total(
                      data.filter((item) => item.status_bill !== 2),
                      "add_on_reduce_debt"
                    )
                ),
                rowSpan: 2,
              },
              {
                text: toFixed(
                  total(
                    data.filter((item) => item.status_bill !== 2),
                    "meter_connect_cost"
                  )
                ),
              },
              {
                text: toFixed(
                  total(
                    data.filter((item) => item.status_bill !== 2),
                    "late_payment"
                  )
                ),
              },
              {
                text: toFixed(
                  total(
                    data.filter((item) => item.status_bill !== 2),
                    "change_satang"
                  )
                ),
              },
            ],
            [
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              { text: "รวมทั้งสิ้น", fillColor: "#C0C0C0" },
              {
                text: toFixed(
                  total(
                    data.filter((item) => item.status_bill !== 2),
                    "total_final"
                  )
                ),
                fillColor: "#C0C0C0",
                colSpan: 2,
              },
              "",
            ],
            [
              { text: "สรุปฝากเข้าบัญชีค่าน้ำและค่าส่วนกลาง", colSpan: 10, alignment: "right" },
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              { text: "เป็นเงิน", fillColor: "#C0C0C0" },
              {
                text: toFixed(
                  total(
                    data_cash.filter((item) => item.status_bill !== 2),
                    "total_final"
                  )
                ),
                fillColor: "#C0C0C0",
                colSpan: 2,
              },
              "",
            ],
            [
              { text: "สรุปยอดโอนเงินเข้าบัญชีนิติ", colSpan: 10, alignment: "right" },
              " ",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              { text: "เป็นเงิน", fillColor: "#C0C0C0" },
              {
                text: toFixed(
                  total(
                    data_tranfer.filter((item) => item.status_bill !== 2),
                    "total_final"
                  )
                ),
                fillColor: "#C0C0C0",
                colSpan: 2,
              },
              "",
            ],
          ],
        },
      },
      { text: " " },
      { text: "สรุปการใช้ใบเสร็จ : มีการรับค่าน้ำรวม ทั้งหมด " + total(data.filter((item) => item.status_bill !== 2), "count_bill") + " รายการโดยใช้ใบเสร็จ ทั้งหมด " + data.length + " ฉบับ และ มีการยกเลิกใบเสร็จ " + data.filter((item) => item.status_bill === 2).length + " ฉบับ", alignment: "left" },
      { text: " " },
      {
        columns: [
          { text: "ลงชื่อผู้ตรวจสอบ.......................................................วันที่................................................", alignment: "left" },
          { text: "ลงชื่อผู้ตรวจสอบ.......................................................วันที่................................................", alignment: "right" },
        ],
      },
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 9, lineHeight: 0.9 },
    pageSize: "A4",
    pageMargins: [15, 15, 15, 15],
  };
  let textDocDefinition = await replaceText(docDefinition);
  open(textDocDefinition, "รายงานการนำส่งเงินค่าใช้จ่ายเข้าบัญชีธนาคาร " + new Date().toISOString() + ".pdf");
}
export { report_remittance_byid };
